module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/XP_RESERVE.125292a0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/XP_RESERVE.png
// module id = 1314
// module chunks = 16